import { purchaseParams } from "./payload.js";

const CHAVE = "sd:analytics:purchases";
const LIMITE = 20;

function lidos(storage) {
  try {
    const bruto = storage?.getItem(CHAVE);
    const ids = JSON.parse(bruto ?? "[]");
    return Array.isArray(ids) ? ids : [];
  } catch {
    return [];
  }
}

/** Já houve envio de `purchase` para este pedido? (CA-10) */
export function wasPurchaseSent(orderId, storage) {
  if (!orderId) {
    return false;
  }
  return lidos(storage).includes(String(orderId));
}

/** Registra que o `purchase` deste pedido foi enviado (CA-10). */
export function markPurchaseSent(orderId, storage) {
  if (!orderId) {
    return;
  }
  try {
    const ids = lidos(storage).filter((id) => id !== String(orderId));
    ids.push(String(orderId));
    storage.setItem(CHAVE, JSON.stringify(ids.slice(-LIMITE)));
  } catch {
    // Armazenamento indisponível (aba privada, storage bloqueado): sem dedupe,
    // mas sem quebrar o fechamento do pedido.
  }
}

/**
 * Evento de compra, ou null quando não há pedido concluído ou ele já foi
 * enviado (CA-8, CA-9, CA-10).
 */
export function purchaseEvent(order, storage) {
  const orderId = order?.orderId;
  if (!orderId) {
    return null;
  }
  if (wasPurchaseSent(orderId, storage)) {
    return null;
  }
  markPurchaseSent(orderId, storage);
  return { name: "purchase", params: purchaseParams(order) };
}
